// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","774":"framework"}[chunkId] || chunkId) + "-" + {"217":"ed98b3e2303840016ccb","231":"0512328cc56227d481ef","532":"864ba8425888c6d7083e","678":"364e8062123ea6a00f86","774":"f92586ccbe9e1bf07e6e"}[chunkId] + ".js";
};